<ion-item-group [formGroup]="form">
	<ion-grid class="ion-no-padding">
		<ion-row
			class="ion-no-padding"
			[ngClass]="dynamicFormControl.controlType === formControlType.Textarea ? 'textArea' : 'inputElement'"
		>
			<ion-col size="5">
				<ion-label [attr.for]="dynamicFormControl.key">
					{{ dynamicFormControl.label }}
					<ng-container *ngIf="dynamicFormControl.required">*</ng-container>
				</ion-label>
			</ion-col>

			<ion-col [size]="gridFieldSize" [ngSwitch]="dynamicFormControl.controlType">
				<ng-container *ngIf="dynamicFormControl.key !== 'standard_number'">
					<ion-input
						[readonly]="dynamicFormControl.disabled"
						appDebounceKeyUpDirective
						[debounce]="isDebounceApplied ? 150 : 0"
						*ngSwitchCase="formControlType.Textbox"
						name="dynamicFormControl.key"
						[formControlName]="dynamicFormControl.key"
						[ngClass]="{
							'error-class':
								form.get(dynamicFormControl.key).invalid &&
								(form.get(dynamicFormControl.key).dirty || form.get(dynamicFormControl.key).touched),
							'disabled-class': dynamicFormControl.disabled
						}"
					></ion-input>
				</ng-container>
				<ng-container *ngIf="dynamicFormControl.key === 'standard_number'">
					<ion-input
						pattern="^[^&#34;',;~@#]*$"
						[readonly]="dynamicFormControl.disabled"
						appDebounceKeyUpDirective
						[debounce]="isDebounceApplied ? 150 : 0"
						*ngSwitchCase="formControlType.Textbox"
						name="dynamicFormControl.key"
						[formControlName]="dynamicFormControl.key"
						[ngClass]="{
							'error-class':
								form.get(dynamicFormControl.key).invalid &&
								(form.get(dynamicFormControl.key).dirty || form.get(dynamicFormControl.key).touched),
							'disabled-class': dynamicFormControl.disabled
						}"
					></ion-input>
				</ng-container>

				<app-numeric-input
					[formControlName]="dynamicFormControl.key"
					*ngSwitchCase="formControlType.Numeric"
					[dynamicFormControl]="dynamicFormControl"
					[form]="form"
					[isDebounceApplied]="isDebounceApplied"
				>
				</app-numeric-input>

				<app-gps-input
					[formControlName]="dynamicFormControl.key"
					*ngSwitchCase="formControlType.Gps"
					[dynamicFormControl]="dynamicFormControl"
					[form]="form"
					[isDebounceApplied]="isDebounceApplied"
				>
				</app-gps-input>

				<ion-checkbox
					[disabled]="dynamicFormControl.disabled"
					[formControlName]="dynamicFormControl.key"
					[checked]="dynamicFormControl.value"
					mode="md"
					*ngSwitchCase="formControlType.CheckBox"
				></ion-checkbox>

				<app-signature-button
					[disabled]="dynamicFormControl.disabled"
					[formControlName]="dynamicFormControl.key"
					[dynamicFormControl]="dynamicFormControl"
					[form]="form"
					*ngSwitchCase="formControlType.Signature"
				></app-signature-button>

				<app-search-select-input
					[formControlName]="dynamicFormControl.key"
					*ngSwitchCase="formControlType.Dropdown"
					[dynamicFormControl]="dynamicFormControl"
					[form]="form"
				>
				</app-search-select-input>

				<app-date-picker
					[formControlName]="dynamicFormControl.key"
					*ngSwitchCase="formControlType.DatePicker || formControlType.TimePicker"
					[dynamicFormControl]="dynamicFormControl"
					[form]="form"
				></app-date-picker>

				<app-formula-input
					[formControlName]="dynamicFormControl.key"
					*ngSwitchCase="formControlType.Formula"
					[dynamicFormControl]="dynamicFormControl"
					[form]="form"
				></app-formula-input>

				<ion-textarea
					[readonly]="dynamicFormControl.disabled"
					appDebounceKeyUpDirective
					[debounce]="isDebounceApplied ? 150 : 0"
					rows="2"
					*ngSwitchCase="formControlType.Textarea"
					name="dynamicFormControl.key"
					[formControlName]="dynamicFormControl.key"
					[ngClass]="{
						'error-class':
							form.get(dynamicFormControl.key).invalid &&
							(form.get(dynamicFormControl.key).dirty || form.get(dynamicFormControl.key).touched),
						'disabled-class': dynamicFormControl.disabled
					}"
					
				>
				</ion-textarea>
			</ion-col>
		</ion-row>
		<ion-row class="messages">
			<ion-col size="5"></ion-col>

			<ion-col [size]="gridFieldSize" [ngSwitch]="dynamicFormControl.controlType">
				<ng-container *ngFor="let validation of dynamicFormControl.validationMessages">
					<ion-note
						*ngIf="
							form.get(dynamicFormControl.key).errors &&
							form.get(dynamicFormControl.key).errors[validation.type] &&
							form.get(dynamicFormControl.key).invalid &&
							(form.get(dynamicFormControl.key).dirty || form.get(dynamicFormControl.key).touched)
						"
					>
						{{ validation.message }}
						<ng-container
							*ngIf="
								validation.type === formControlErrorTypes.greaterThan ||
								validation.type === formControlErrorTypes.lessThan
							"
						>
							{{ form.get(dynamicFormControl.key).errors[validation.type] }}
						</ng-container>
					</ion-note>
				</ng-container>
				<ng-container>
					<ion-note *ngIf="form.get(dynamicFormControl.key)?.errors?.pattern">
						This special character is not supported
					</ion-note>
				</ng-container>
			</ion-col>
		</ion-row>
	</ion-grid>
</ion-item-group>
